import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LoadingOverlay } from "../LoadingOverlay";
import { ReactNode } from "react";

interface FormContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isSubmitting?: boolean;
  children: ReactNode;
  title?: string;
}

export const FormContainer = ({ 
  open, 
  onOpenChange, 
  isSubmitting, 
  children,
  title = "Schedule Integration Consultation"
}: FormContainerProps) => {
  return (
    <Dialog 
      open={open} 
      onOpenChange={onOpenChange}
    >
      <DialogContent 
        className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto"
        role="dialog"
        aria-modal="true"
        aria-labelledby="dialog-title"
      >
        <DialogHeader>
          <DialogTitle 
            id="dialog-title"
            className="text-2xl font-semibold"
          >
            {title}
          </DialogTitle>
        </DialogHeader>

        {isSubmitting && <LoadingOverlay />}
        
        {children}
      </DialogContent>
    </Dialog>
  );
};